import './App.css'
import Router from './router/router.tsx'

function App() {
	return (
		<div className='App'>
			<Router />
		</div>
	)
}

export default App
